// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  GeometryBindingKind,
} from "./types";


export default __t.row({
  bindingId: __t.u64().primaryKey().name("binding_id"),
  twinId: __t.string().name("twin_id"),
  get kind() {
    return GeometryBindingKind;
  },
  enabled: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
});
